import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDefaultSort = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.3294 7.78566C12.443 7.89869 12.5 8.03389 12.5 8.19138C12.5 8.34606 12.443 8.47976 12.3294 8.59268L11.9924 8.92703C11.8846 9.04017 11.7498 9.09647 11.5879 9.09647C11.4262 9.09647 11.2914 9.04017 11.1837 8.92703L9.86273 7.62075V10.7595C9.86273 10.9142 9.80656 11.0397 9.6942 11.1364C9.58184 11.2329 9.44615 11.2812 9.2874 11.2812H8.71264C8.55391 11.2812 8.4182 11.2329 8.30585 11.1364C8.19378 11.0397 8.1376 10.9142 8.1376 10.7595V7.62075L6.82127 8.92703C6.70718 9.04017 6.57092 9.09647 6.41217 9.09647C6.25343 9.09647 6.11716 9.04017 6.00337 8.92703L5.66629 8.59268C5.55565 8.47685 5.50005 8.34295 5.50005 8.19138C5.50005 8.03701 5.55565 7.9017 5.66629 7.78566L8.59135 4.8832C8.70199 4.77329 8.83826 4.71829 9.00017 4.71829C9.16468 4.71829 9.2995 4.77329 9.40438 4.8832L12.3294 7.78566Z",
			fill: "#7F99B2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 1.5H15V-0.5H3V1.5ZM17 3.5V12.5H19V3.5H17ZM15 14.5H3V16.5H15V14.5ZM1 12.5V3.5H-1V12.5H1ZM3 14.5C1.89543 14.5 1 13.6046 1 12.5H-1C-1 14.7091 0.790862 16.5 3 16.5V14.5ZM17 12.5C17 13.6046 16.1046 14.5 15 14.5V16.5C17.2091 16.5 19 14.7091 19 12.5H17ZM15 1.5C16.1046 1.5 17 2.39543 17 3.5H19C19 1.29086 17.2091 -0.5 15 -0.5V1.5ZM3 -0.5C0.790861 -0.5 -1 1.29086 -1 3.5H1C1 2.39543 1.89543 1.5 3 1.5V-0.5Z",
			fill: "#7F99B2"
		})
	]
});
const ForwardRef = forwardRef(SvgDefaultSort);
export { ForwardRef as ReactComponent };
